import { render, staticRenderFns } from "./StockScoreDetail.vue?vue&type=template&id=0db6cf50&scoped=true&"
import script from "./StockScoreDetail.vue?vue&type=script&lang=js&"
export * from "./StockScoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./StockScoreDetail.vue?vue&type=style&index=0&id=0db6cf50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db6cf50",
  null
  
)

export default component.exports